import script from "./Startsida.vue?vue&type=script&setup=true&lang=ts"
export * from "./Startsida.vue?vue&type=script&setup=true&lang=ts"

import "./Startsida.vue?vue&type=style&index=0&id=1f041337&lang=scss"

const __exports__ = script;

export default __exports__